export const environment = {
  production: true,
  version: '1.0.0.43',
  baseUrl: 'https://budget.hafencity.com',
  baseAPIUrl: 'https://budget.hafencity.com',
  auth: {
      clientId: '71a3af0f-8330-45ce-b699-4692558d9414',
      authority: 'https://login.microsoftonline.com/38f97e8f-b3f1-4ec9-8cb1-d943020b261b',
      redirectUri: 'https://budget.hafencity.com',
      navigateToLoginRequestUrl: false
    }
};
